import { createBundle } from 'widget/Common';

import PunchClockView from 'bundle-loader?lazy&name=PunchClockView!pages/PunchClock/PunchClockView';
import ChangeBgImgView from 'bundle-loader?lazy&name=ChangeBgImgView!pages/PunchClock/ChangeBgImg/ChangeBgImgView';
import ReissueClockView from 'bundle-loader?lazy&name=ReissueClockView!pages/PunchClock/ReissueClock/ReissueClockView';
import SetQrcodeView from 'bundle-loader?lazy&name=SetQrcodeView!pages/PunchClock/SetQrcode/SetQrcodeView';
import FriendrankingView from 'bundle-loader?lazy&name=FriendrankingView!pages/PunchClock/Friendranking/FriendrankingView';
import PunchClockSetView from 'bundle-loader?lazy&name=PunchClockSetView!pages/PunchClock/PunchClockSet/PunchClockSetView';
import BeanHomeView from 'bundle-loader?lazy&name=BeanHomeView!pages/PunchClock/Bean/BeanHome/BeanHomeView';
import BeanRulerView from 'bundle-loader?lazy&name=BeanHomeView!pages/PunchClock/Bean/BeanRuler/BeanRulerView';
import MyBean from 'bundle-loader?lazy&name=BeanHomeView!pages/PunchClock/Bean/MyBean/MyBeanView';
import HotSaleListView from 'bundle-loader?lazy&name=HotSaleListView!pages/PunchClock/Bean/HotSaleList/HotSaleListView';
import RecommendBeanListView from 'bundle-loader?lazy&name=HotSaleListView!pages/PunchClock/Bean/RecommendBeanList';
import ExChangeCouponListView from 'bundle-loader?lazy&name=ExChangeCouponListView!pages/PunchClock/Bean/ExChangeCouponList/ExChangeCouponListView';
// import ExChangeListView from 'bundle-loader?lazy&name=ExChangeListView!pages/PunchClock/Bean/ExChangeList/ExChangeListView';
import ExChangeDetailView from 'bundle-loader?lazy&name=ExChangeDetailView!pages/PunchClock/Bean/ExChangeDetail/ExChangeDetailView';
import MyExChangeView from 'bundle-loader?lazy&name=MyExChangeView!pages/PunchClock/Bean/MyExChange/MyExChangeView';
import BeanListView from 'bundle-loader?lazy&name=BeanListView!pages/PunchClock/Bean/BeanList/BeanListView';
import ShoppingBagView from 'bundle-loader?lazy&name=ShoppingBagView!pages/PunchClock/Bean/ShoppingBag/ShoppingBagView';

const RouterConfig = [
  {
    path: '/PunchClock',
    title: '打卡页面',
    component: () => {
      return createBundle(PunchClockView);
    }
  },
  {
    path: '/PunchClock/ChangeBgImg',
    title: '换底图页面',
    component: () => {
      return createBundle(ChangeBgImgView);
    }
  },
  {
    path: '/PunchClock/SetQrcodeView',
    title: '二维码设置',
    component: () => {
      return createBundle(SetQrcodeView);
    }
  },
  {
    path: '/PunchClock/ReissueClock',
    title: '补签页面',
    component: () => {
      return createBundle(ReissueClockView);
    }
  },
  {
    path: '/PunchClock/FriendrankingView',
    title: '好友排名',
    component: () => {
      return createBundle(FriendrankingView);
    }
  },
  {
    path: '/PunchClock/PunchClockSet',
    title: '设置',
    component: () => {
      return createBundle(PunchClockSetView);
    }
  },
  {
    path: '/PunchClock/BeanHome',
    title: '我的三生豆首页',
    component: () => {
      return createBundle(BeanHomeView);
    }
  },
  {
    path: '/PunchClock/BeanRuler',
    title: '三生豆过期规则',
    component: () => {
      return createBundle(BeanRulerView);
    }
  },
  {
    path: '/PunchClock/MyBean',
    title: '我的三生豆',
    component: () => {
      return createBundle(MyBean);
    }
  },
  {
    path: '/PunchClock/HotSaleList',
    title: '热销商品列表',
    component: () => {
      return createBundle(HotSaleListView);
    }
  },
  {
    path: '/PunchClock/RecommendBeanList',
    title: '三生豆商品列表',
    component: () => {
      return createBundle(RecommendBeanListView);
    }
  },
  {
    path: '/PunchClock/ExChangeList',
    title: '兑换优惠卷列表',
    component: () => {
      return createBundle(ExChangeCouponListView);
    }
  },
  {
    path: '/PunchClock/ExChangeDetail',
    title: '兑换优惠卷详情',
    component: () => {
      return createBundle(ExChangeDetailView);
    }
  },
  {
    path: '/PunchClock/MyExChange',
    title: '我的兑换列表',
    component: () => {
      return createBundle(MyExChangeView);
    }
  },
  {
    path: '/PunchClock/BeanList',
    title: '我的兑换列表',
    component: () => {
      return createBundle(BeanListView);
    }
  },
  {
    path: '/PunchClock/ShoppingBag',
    title: '购物袋',
    component: () => {
      return createBundle(ShoppingBagView);
    }
  }
];

export default RouterConfig;



// WEBPACK FOOTER //
// ./src/pages/PunchClock/RouterConfig.js